import { render, staticRenderFns } from "./Inscricao.vue?vue&type=template&id=0a779191&scoped=true"
import script from "./Inscricao.vue?vue&type=script&lang=js"
export * from "./Inscricao.vue?vue&type=script&lang=js"
import style0 from "./Inscricao.vue?vue&type=style&index=0&id=0a779191&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a779191",
  null
  
)

export default component.exports